import { render } from "./info.vue?vue&type=template&id=76abdfca&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=76abdfca&scoped=true&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76abdfca"]])

export default __exports__